import { GetServerSideProps } from 'next';
import SEOHead from '../../components/SEOHead';

export default function AplikacijuProgramavimasPage() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: 'Aplikacijų programavimas',
    description: 'Profesionalus aplikacijų programavimas Lietuvoje. Individualūs programinės įrangos sprendimai, sukurti naudojant šiuolaikines technologijas verslams, siekiantiems skaitmeninės transformacijos.',
    provider: {
      '@type': 'Organization',
      name: 'LB Visible',
      url: 'https://www.lbvisible.com',
      knowsAbout: [
        'Aplikacijų programavimas',
        'Programų kūrimas',
        'Individualūs programinės įrangos sprendimai',
        'Skaitmeninė transformacija',
        'Įmonių programinė įranga',
      ],
    },
    areaServed: {
      '@type': 'Country',
      name: 'Lithuania',
    },
  };

  return (
    <>
      <SEOHead
        title='Aplikacijų programavimas | LBVisible'
        description='Profesionalus aplikacijų programavimas Lietuvoje. Individualūs programinės įrangos sprendimai, sukurti naudojant šiuolaikines technologijas verslams, siekiantiems skaitmeninės transformacijos.'
        keywords='aplikacijų programavimas, programų kūrimas, individualūs programinės įrangos sprendimai, aplikacijų programavimas Lietuvoje, įmonių programinė įranga'
        canonicalUrl='/lt/aplikaciju-programavimas'
        lang='lt'
        structuredData={structuredData}
      />

      <main className='min-h-screen max-w-4xl mx-auto px-4 sm:px-6 py-12'>
        <article className='prose prose-lg dark:prose-invert max-w-none'>
          <style jsx global>{`
            article h1 {
              font-size: 2.25rem;
              font-weight: 700;
              margin-top: 2rem;
              margin-bottom: 1.5rem;
              line-height: 1.2;
            }
            article h2 {
              font-size: 1.875rem;
              font-weight: 700;
              margin-top: 2rem;
              margin-bottom: 1rem;
              line-height: 1.3;
            }
            article h3 {
              font-size: 1.5rem;
              font-weight: 600;
              margin-top: 1.5rem;
              margin-bottom: 0.75rem;
              line-height: 1.4;
            }
            article p {
              margin-bottom: 1.5rem;
              line-height: 1.75;
            }
            article p {
              color: rgb(55 65 81);
            }
            :global(html.dark) article p {
              color: rgb(209 213 219);
            }
          `}</style>
          <h1>Aplikacijų programavimas ir kūrimas</h1>
          
          <h2>Kodėl profesionalus aplikacijų programavimas svarbus</h2>
          <p>
            Aplikacijų programavimas yra šiuolaikinių verslų skaitmeninės transformacijos pagrindas. 
            Individualūs programinės įrangos sprendimai leidžia įmonėms automatizuoti procesus, pagerinti 
            efektyvumą ir įgyti konkurencinius pranašumus. Profesionalus aplikacijų programavimas užtikrina, 
            kad jūsų programos būtų patikimos, saugios, mastuojamos ir atitinka jūsų verslo tikslus. Nesvarbu, 
            ar jums reikia darbalaukių programų, mobiliųjų programėlių ar debesų sprendimų, profesionalus 
            kūrimas yra būtinas sėkmei.
          </p>

          <h2>Mūsų aplikacijų programavimo procesas</h2>
          <p>
            Mūsų aplikacijų programavimo procesas yra sukurtas pristatyti aukštos kokybės sprendimus, kurie 
            atitinka jūsų verslo poreikius. Pradedame nuo jūsų reikalavimų supratimo, jūsų darbo procesų 
            analizės ir pagerinimo galimybių nustatymo. Tada projektuojame programinės įrangos architektūrą, 
            parenkame tinkamas technologijas ir kurime individualius sprendimus naudodami geriausias praktikas 
            ir pramonės standartus. Visą kūrimo procesą palaikome aiškų komunikaciją, teikiame reguliarų 
            atnaujinimą ir užtikriname kokybę per testavimą ir kodo peržiūras.
          </p>

          <h3>Individualių programų kūrimas</h3>
          <p>
            Kurime individualias programas, pritaikytas jūsų specifiniams verslo poreikiams. Mūsų programų 
            kūrimo paslaugos apima įvairias platformas ir technologijas, užtikrindamos, kad jūsų programinė 
            įranga sklandžiai veiktų skirtingose aplinkose. Orientuojamės į intuityvių vartotojo sąsajų, 
            tvirtų funkcijų ir patikimo našumo kūrimą.
          </p>

          <h3>Įmonių programinės įrangos sprendimai</h3>
          <p>
            Didesnėms organizacijoms kurime įmonių programinės įrangos sprendimus, kurie integruojasi su 
            esamomis sistemomis ir palaiko sudėtingus verslo procesus. Mūsų įmonių programinės įrangos 
            kūrimo paslaugos apima sistemos integraciją, duomenų migraciją ir tęstinę paramą, kad jūsų 
            programinė įranga ir toliau atitiktų jūsų besikeičiančius poreikius.
          </p>

          <h2>Kodėl rinktis LBVISIBLE aplikacijų programavimui</h2>
          <p>
            Teisingo aplikacijų programavimo partnerio pasirinkimas yra labai svarbus jūsų verslo tikslų 
            pasiekimui. LBVISIBLE mes sujungiame techninę patirtį su verslo supratimu, kad pristatytume 
            programinės įrangos sprendimus, kurie duoda rezultatų. Naudojame šiuolaikines technologijas, 
            laikomės geriausių praktikų ir palaikome aukštus kokybės standartus visą kūrimo procesą.
          </p>

          <p>
            Mūsų aplikacijų programavimo paslaugos apima individualų kūrimą, sistemos integraciją, API 
            kūrimą, duomenų bazės dizainą ir tęstinę priežiūrą. Dirbame glaudžiai su jumis, kad užtikrintume, 
            jog jūsų programinė įranga atitiktų jūsų reikalavimus ir efektyviai palaikytų jūsų verslo tikslus.
          </p>

          <p>
            Nesvarbu, ar jums reikia naujos programos, norite modernizuoti esamą programinę įrangą ar reikia 
            integracijos paslaugų, turime patirtį, kad padėtume jums sėkmės. Susisiekite su mumis šiandien, 
            kad aptartumėte savo aplikacijų programavimo poreikius ir sužinotumėte, kaip galime padėti jūsų 
            verslui pasiekti skaitmeninę transformaciją.
          </p>
        </article>
      </main>
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async () => {
  return {
    props: {},
  };
};

